import { useState, useEffect } from 'react';
import classNames from 'classnames';
import ChoiceDistributor from './ChoiceDistributor';
import Titles from './Titles';
import WidgetActions from './WidgetActions';
import Configurator from './Configurator';
import SubmitForm from './SubmitForm';


//load files from react local
if(window.CRBVars === undefined) {
	window.CRBVars = {
		"reactAppUri": ''
	};
};

function ConfiguratorPage() {
	const [items, setItems] = useState([]);
	const [currentStep, setCurrentStep] = useState(1);
	const [allSteps, setAllSteps] = useState(3);
	const [selectedData, setSelectedData] = useState(false);
	const [model, setModel] = useState({});
	const [modelTop, setModelTop] = useState({});
	const [modelTopColor, setModelTopColor] = useState({});
	const [modelValance, setModelValance] = useState({});
	const [modelFringe, setModelFringe] = useState({});
	const [modelBottom, setModelBottom] = useState({});
	const [hideMobileMenu, setHideMobileMenu] = useState(false);
	const [loadedObjects, setLoadedObjects] = useState({});

	useEffect(() => {
		const newItems = {
			models: [
				{
					groupTitle: "Choose a Model",
					name: "King",
					image: "https://wp-files.poggesiusa.com/last/images/product-1.png",
					parts: {
						main: {
							groupTitle: "Choose Structure Color",
							drawing: "https://wp-files.poggesiusa.com/last/structure/structure_bronze.glb",
							colors: [
								{
									name: "Structure Bronze",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_bronze.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_bronze-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_bronze-1.png",
								},
								{
									name: "Structure Black",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_black.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_black-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_black-1.png",
								}, {
									name: "Structure Chrome",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_chrome.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_chrome-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_chrome-1.png",
								}, {
									name: "Structure Cream",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_cream.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_cream-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_cream-1.png",
								}, {
									name: "Structure Faux Wood",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_faux_wood.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_faux_wood-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_faux_wood-1.png",
								}, {
									name: "Structure Graphaite",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_graphaite.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_graphaite-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_graphaite-1.png",
								}, {
									name: "Structure White",
									preview: "https://wp-files.poggesiusa.com/last/images/structure_white.png",
									texture: "https://wp-files.poggesiusa.com/last/structure/structure_white-0.png",
									texture2: "https://wp-files.poggesiusa.com/last/structure/structure_white-1.png",
								}
							]
						},
						top: {
							groupTitle: "Choose Top Model",
							list: [
								{
									name: "Square",
									drawing: "https://wp-files.poggesiusa.com/last/top/top_red.glb",
									preview: "https://wp-files.poggesiusa.com/last/images/image-top.jpg",
									colors: {
										groupTitle: "Choose Color",
										list: [
											{
												name: "Red",
												preview: "https://wp-files.poggesiusa.com/last/images/top_red.png",
												topTexture: "https://wp-files.poggesiusa.com/last/top/top_red_texture.png",
												valancesTextures: {
													valance_a: "https://wp-files.poggesiusa.com/last/valance/valance_a_red.png",
													valance_b: "https://wp-files.poggesiusa.com/last/valance/valance_b_red.png",
													valance_c: "https://wp-files.poggesiusa.com/last/valance/valance_c_red.png",
													valance_d: "https://wp-files.poggesiusa.com/last/valance/valance_d_red.png",
													valance_e: "https://wp-files.poggesiusa.com/last/valance/valance_e_red.png",
													valance_g: "https://wp-files.poggesiusa.com/last/valance/valance_g_red.png",
													valance_h: "https://wp-files.poggesiusa.com/last/valance/valance_h_red.png",
													valance_i: "https://wp-files.poggesiusa.com/last/valance/valance_i_red.png",
													valance_l: "https://wp-files.poggesiusa.com/last/valance/valance_l_red.png",
												}
											},
											{
												name: "Blue",
												preview: "https://wp-files.poggesiusa.com/last/images/top_blue.png",
												topTexture: "https://wp-files.poggesiusa.com/last/top/top_blue_texture.png",
												valancesTextures: {
													valance_a: "https://wp-files.poggesiusa.com/last/valance/valance_a_blue.png",
													valance_b: "https://wp-files.poggesiusa.com/last/valance/valance_b_blue.png",
													valance_c: "https://wp-files.poggesiusa.com/last/valance/valance_c_blue.png",
													valance_d: "https://wp-files.poggesiusa.com/last/valance/valance_d_blue.png",
													valance_e: "https://wp-files.poggesiusa.com/last/valance/valance_e_blue.png",
													valance_g: "https://wp-files.poggesiusa.com/last/valance/valance_g_blue.png",
													valance_h: "https://wp-files.poggesiusa.com/last/valance/valance_h_blue.png",
													valance_i: "https://wp-files.poggesiusa.com/last/valance/valance_i_blue.png",
													valance_l: "https://wp-files.poggesiusa.com/last/valance/valance_l_blue.png",
												}
											},
											{
												name: "Buttercup",
												preview: "https://wp-files.poggesiusa.com/last/images/top_buttercup.png",
												topTexture: "https://wp-files.poggesiusa.com/last/top/top_buttercup_texture.png",
												valancesTextures: {
													valance_a: "https://wp-files.poggesiusa.com/last/valance/valance_a_buttercup.png",
													valance_b: "https://wp-files.poggesiusa.com/last/valance/valance_b_buttercup.png",
													valance_c: "https://wp-files.poggesiusa.com/last/valance/valance_c_buttercup.png",
													valance_d: "https://wp-files.poggesiusa.com/last/valance/valance_d_buttercup.png",
													valance_e: "https://wp-files.poggesiusa.com/last/valance/valance_e_buttercup.png",
													valance_g: "https://wp-files.poggesiusa.com/last/valance/valance_g_buttercup.png",
													valance_h: "https://wp-files.poggesiusa.com/last/valance/valance_h_buttercup.png",
													valance_i: "https://wp-files.poggesiusa.com/last/valance/valance_i_buttercup.png",
													valance_l: "https://wp-files.poggesiusa.com/last/valance/valance_l_buttercup.png",
												}
											},
											{
												name: "ginko",
												preview: "https://wp-files.poggesiusa.com/last/images/top_ginko.png",
												topTexture: "https://wp-files.poggesiusa.com/last/top/top_ginko_texture.png",
												valancesTextures: {
													valance_a: "https://wp-files.poggesiusa.com/last/valance/valance_a_ginko.png",
													valance_b: "https://wp-files.poggesiusa.com/last/valance/valance_b_ginko.png",
													valance_c: "https://wp-files.poggesiusa.com/last/valance/valance_c_ginko.png",
													valance_d: "https://wp-files.poggesiusa.com/last/valance/valance_d_ginko.png",
													valance_e: "https://wp-files.poggesiusa.com/last/valance/valance_e_ginko.png",
													valance_g: "https://wp-files.poggesiusa.com/last/valance/valance_g_ginko.png",
													valance_h: "https://wp-files.poggesiusa.com/last/valance/valance_h_ginko.png",
													valance_i: "https://wp-files.poggesiusa.com/last/valance/valance_i_ginko.png",
													valance_l: "https://wp-files.poggesiusa.com/last/valance/valance_l_ginko.png",
												}
											},
											{
												name: "orange",
												preview: "https://wp-files.poggesiusa.com/last/images/top_orange.png",
												topTexture: "https://wp-files.poggesiusa.com/last/top/top_orange_texture.png",
												valancesTextures: {
													valance_a: "https://wp-files.poggesiusa.com/last/valance/valance_a_orange.png",
													valance_b: "https://wp-files.poggesiusa.com/last/valance/valance_b_orange.png",
													valance_c: "https://wp-files.poggesiusa.com/last/valance/valance_c_orange.png",
													valance_d: "https://wp-files.poggesiusa.com/last/valance/valance_d_orange.png",
													valance_e: "https://wp-files.poggesiusa.com/last/valance/valance_e_orange.png",
													valance_g: "https://wp-files.poggesiusa.com/last/valance/valance_g_orange.png",
													valance_h: "https://wp-files.poggesiusa.com/last/valance/valance_h_orange.png",
													valance_i: "https://wp-files.poggesiusa.com/last/valance/valance_i_orange.png",
													valance_l: "https://wp-files.poggesiusa.com/last/valance/valance_l_orange.png",
												}
											}
										]
									},
									valance: {
										groupTitle: "Choose Valance",
										list: [
											{
												name: "Valance A",
												id: "valance_a",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_a_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_a_red.png",

												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_a",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_a.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_a.png",
														}
													]
												}
											},
											{
												name: "Valance C",
												id: "valance_c",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_c_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_c_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_c",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_c.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_c.png",
														}
													]
												}
											},
											{
												name: "Valance D",
												id: "valance_d",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_d_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_d_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_d",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_d.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_d.png",
														}
													]
												}
											},
											{
												name: "Valance E",
												id: "valance_e",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_e_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_e_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_e",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_e.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_e.png",
														}
													]
												}
											},
											{
												name: "Valance G",
												id: "valance_g",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_g_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_g_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_g",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_g.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_g.png",
														}
													]
												}
											},
											{
												name: "Valance H",
												id: "valance_h",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_h_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_h_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_h",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_h.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_h.png",
														}
													]
												}
											},
											{
												name: "Valance I",
												id: "valance_i",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_i_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_i_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_i",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_i.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_i.png",
														}
													]
												}
											},
											{
												name: "Valance L",
												id: "valance_l",
												drawing: "https://wp-files.poggesiusa.com/last/valance/valance_l_red.glb",
												preview: "https://wp-files.poggesiusa.com/last/images/valance_l_red.png",
												fringe: {
													groupTitle: "Choose Fringe",
													list: [
														{
															name: "fringe_l",
															drawing: "https://wp-files.poggesiusa.com/last/fringe/fringe_l.glb",
															preview: "https://wp-files.poggesiusa.com/last/images/fringe_l.png",
														}
													]
												}
											}
										]
									}
								}
							]
						},
						bottom: {
							groupTitle: "Choose Bottom",
							list: [
								{
									name: "Base 1",
									drawing: "https://wp-files.poggesiusa.com/last/bottom/base01.glb",
									preview: "https://wp-files.poggesiusa.com/last/images/base01.png"
								}, {
									name: "Base 2",
									drawing: "https://wp-files.poggesiusa.com/last/bottom/base02.glb",
									preview: "https://wp-files.poggesiusa.com/last/images/base02.png"
								}, {
									name: "Base 3",
									drawing: "https://wp-files.poggesiusa.com/last/bottom/base03.glb",
									preview: "https://wp-files.poggesiusa.com/last/images/base03.png"
								}, {
									name: "Base 4",
									drawing: "https://wp-files.poggesiusa.com/last/bottom/base04.glb",
									preview: "https://wp-files.poggesiusa.com/last/images/base04.png"
								},
							]
						}
					}
				}
			]
		};
		setItems(newItems);
	}, []);

	return (
		<section className={classNames('section-configurator-alt js-configurator', { 'is-menu-hidden': hideMobileMenu })}>
			<div className="section__inner">
				<div className="section__main">
					<div className="section__head"></div>

					<div className="section__media">
						<Configurator
							model={model}
							selectedData={selectedData}
							setModel={setModel}
							modelTop={modelTop}
							modelTopColor={modelTopColor}
							modelValance={modelValance}
							modelFringe={modelFringe}
							modelBottom={modelBottom}
							loadedObjects={loadedObjects}
							setLoadedObjects={setLoadedObjects}
							
						/>
					</div>
				</div>

				<div className="section__aside">
					<div className="section__aside-head" style={{ width: '10px', margin: '0 auto' }}>
						<a
							href="#"
							className="section__aside-btn"
							onClick={(e) => {
								e.preventDefault();
								setHideMobileMenu(!hideMobileMenu);
							}}
						>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
								<path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" />
							</svg>

						</a>
					</div>

					<div className="widget-configurator">
						<div className="widget__head">
							<Titles
								selectedData={selectedData}
								currentStep={currentStep}
								model={model}
								modelTop={modelTop}
								modelValance={modelValance}
								modelFringe={modelFringe}
								modelBottom={modelBottom}
								modelTopColor={modelTopColor}
							/>
						</div>

						<div className="widget__body">
							{ currentStep <= allSteps && (
								<ChoiceDistributor
									loadedObjects={loadedObjects}
									setLoadedObjects={setLoadedObjects}

									items={items}
									
									selectedData={selectedData}
									setSelectedData={setSelectedData}

									currentStep={currentStep}
									setCurrentStep={setCurrentStep}

									allSteps={allSteps}
									setAllSteps={setAllSteps}

									model={model}
									setModel={setModel}

									modelTop={modelTop}
									setModelTop={setModelTop}

									modelValance={modelValance}
									setModelValance={setModelValance}

									modelFringe={modelFringe}
									setModelFringe={setModelFringe}

									modelTopColor={modelTopColor}
									setModelTopColor={setModelTopColor}

									modelBottom={modelBottom}
									setModelBottom={setModelBottom}
								/>
							)}
							{ currentStep > allSteps && (
								<SubmitForm
									selectedData={selectedData}
									model={model}
								/>
							)}
						</div>

						<WidgetActions
							selectedData={selectedData}
							allSteps={allSteps}
							currentStep={currentStep}
							setCurrentStep={setCurrentStep}
							items={items}
						/>
					</div>
				</div>
			</div>
		</section >
	);
}

export default ConfiguratorPage;